<app-banners secaoUrl="blog"></app-banners>


<div class="row">
  <div class="col-md-9" *ngIf="post">
    <div class="container ">

      <p class="title-form-pages pt-5" [innerHtml]="post.title.rendered"></p>

      <div class="empresa pb-5">
        <div class="logo">
          <img src="../../../../assets/blog/Logo-blog-detalhes.png" alt="">
        </div>
        <div>
          <div class="blukit pb-0">Blukit</div>
          <div class=" data-logo pt-0">{{ post.date | date: 'dd/MM/yyyy'}}</div>
        </div>
      </div>

      <div class=" pb-5">
        <div class="col-md pb-0 ">
          <main class="descricao-detalhes" [innerHtml]="conteudoHtmlSeguro"></main>
        </div>
      </div>
    </div>
  </div>


  <div class="col-md-3 blog">
    <p class="col-md titulo-categoria pt-1 pb-2 ">Veja também</p>
    <div *ngFor="let post of postsVejaTmb; let i = index">
      <div (click)="openPost(post)">
        <div class="col-md pb-0  post-veja-tambem" *ngIf="i < 2">
          <img class="img-fluid mt-4 imagem" [src]="apiService.getCover(post)" alt="">
          <p class="data">{{ post.date | date: 'dd/MM/yyyy'}} <span class="descricao-categoria" *ngIf="post.categorias && post.categorias.length > 0"> |
            {{post.categorias[0].name}}</span></p>
            <p class="titulo" [innerHtml]="post.title.rendered"></p>
          <div class="descricao limitar-linhas" [innerHtml]="post.excerpt.rendered"></div>
        </div>
      </div>
    </div>

    <a href="/blog">
      <p class="col-md titulo-categoria pt-1 pb-0 mt-5 pb-3"> Categorias</p>
    </a>
    <div class="col-md lista-categorias ">

          <div class="desc-categoria p-2" *ngFor="let categoria of categoria">
            <p *ngIf="categoria" (click)="openCategoriaId(categoria)"> {{ categoria.name.charAt(0).toUpperCase() + categoria.name.slice(1).toLowerCase() }} ({{categoria.count }})  </p>
             </div>
             <p class="desc-categoria p-2" (click)="openCategoriaId()" *ngIf="quantityPostWithOutCategory > 0"> Sem Categoria ({{quantityPostWithOutCategory}})</p>


    </div>
    <p class="col-md titulo-categoria pb-0 mt-5 pb-3"> TAGS</p>
    <button class="tags" (click)="openTag(tag)" *ngFor="let tag of tags">{{ tag.name.charAt(0).toUpperCase() + tag.name.slice(1).toLowerCase() }}</button>
  </div>


</div>
